import { render, staticRenderFns } from "./ContactDropdownItem.vue?vue&type=template&id=60b55455&scoped=true&"
import script from "./ContactDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ContactDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactDropdownItem.vue?vue&type=style&index=0&id=60b55455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b55455",
  null
  
)

export default component.exports